import { apiClient } from './api';

export interface SearchCustomer { id: number; email: string; full_name: string }
export interface SearchSku { id: number; sku_code: string; product_name: string }
export interface SearchOrder {
  id: number;
  status: string;
  total_amount: string | number;
  order_date: string;
  customer_name: string;
}

export interface SearchResults {
  query: string;
  count: number;
  customers?: SearchCustomer[];
  skus?: SearchSku[];
  orders?: SearchOrder[];
}

export async function globalSearch(q: string, types?: string[]): Promise<SearchResults> {
  const params: Record<string, any> = { q };
  if (types && types.length > 0) params.types = types.join(',');
  return apiClient.get<SearchResults>('/search', params);
}
